import { ReactElement, useState } from "react";
import { MenuOutlined } from "@ant-design/icons";
import { Drawer, Dropdown, MenuProps } from "antd";
import { useDispatch, useSelector } from "react-redux";

import "./header.scss";
// import notificationImage from "../../assets/notification.svg";
// import settingImage from "../../assets/setting.svg";
import arrowImage from "../../assets/arrow-down.svg";
// import searchImage from "../../assets/search.svg";
// import SearchInput from "../../components/search-input/search-input";
import SideBar from "../sidebar/sidebar.component";
import { LOGOUT } from "../../store/actions";
import { useLocation, useNavigate } from "react-router-dom";
import CustomModal from "../../components/custom-modal/custom-modal";
import Avatar from "react-avatar";
import EditProfile from "./components/edit-profile/edit-profile";
import LoginService from "src/views/login/login-service";
import SelectBranch from "src/components/select-branch.component";
import TestingEnvLabel from "src/components/testign-env-label.component";

const Header: React.FC = (): ReactElement => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: any) => state.user);
  const loginServiceInstance = new LoginService();
  const [openNotification, setOpenNotification] = useState(false);
  const [open, setOpen] = useState<boolean>(false);
  const [openEditUserModal, setOpenEditUserModal] = useState(false);

  const logout = async () => {
    const response = await loginServiceInstance.logout();
    if (response) {
      dispatch({ type: LOGOUT });
      localStorage.removeItem("star_prev_url");
      navigate("/login", { state: location.pathname });
    }
  };

  const closeDrawer = () => {
    setOpen(false);
  };

  const items: MenuProps["items"] = [
    {
      key: "Update profile",
      label: (
        <span
          className="w-full block"
          onClick={() => setOpenEditUserModal(true)}
        >
          Update profile
        </span>
      ),
    },
    {
      key: "Logout",
      label: (
        <span className="w-full block" onClick={() => logout()}>
          Logout
        </span>
      ),
    },
  ];

  return (
    <div className="header-container flex flex-col gap-y-3 md:flex-row justify-between bg-blue-500 py-5 pe-11">
      <div className="logo flex items-center gap-3 px-5">
        <MenuOutlined className="w-7 h-7" onClick={() => setOpen(true)} />
        <TestingEnvLabel src="/images/header-logo.svg" classes="mb-0" />
        <p className="flex items-center text-white m-0 ms-5 ps-5 text-sm md:text-xl font-medium my-[5px] w-fit whitespace-nowrap">
          App BackOffice
        </p>
      </div>
      <div className="user flex items-center">
        <SelectBranch />
        <div className="hidden md:flex ms-3 w-0.5 h-9 opacity-50 bg-gray-200 rounded-2xl" />
        <div className="account flex items-center mt-3 md:mt-0">
          <Dropdown menu={{ items }}>
            <div className="name flex items-center">
              {user?.picture ? (
                <img
                  src={`data:image/png;base64,${user?.picture}`}
                  alt="Base64 Image"
                  className="w-[46px] h-[46px] rounded-full mx-[15px]"
                />
              ) : (
                <Avatar
                  size="40"
                  className="user-image"
                  name={user?.name}
                  unstyled={true}
                />
              )}
              <p className="text-white text-sm md:text-base lg:text-xl">
                {user?.name}{" "}
              </p>
              <img src={arrowImage} alt="arrow-down-icon" />
            </div>
          </Dropdown>
        </div>
      </div>

      <Drawer
        title="Basic Drawer"
        placement="right"
        onClose={() => setOpenNotification(false)}
        open={openNotification}
        destroyOnClose
        className="min-w-[300px] p-5"
      >
        <p className="text-lg mb-5 text-black-300">Notification 1</p>
        <p className="text-lg mb-5 text-black-300">Notification 2</p>
        <p className="text-lg mb-5 text-black-300">Notification 3</p>
      </Drawer>
      <Drawer
        destroyOnClose={true}
        maskClosable={true}
        onClose={closeDrawer}
        placement="left"
        open={open}
        className="sidebar-drawer"
      >
        <SideBar />
      </Drawer>

      <CustomModal
        isVisible={openEditUserModal}
        centered
        width={900}
        showClose={false}
        onClose={() => {
          setOpenEditUserModal(false);
        }}
        className="edit-modal"
      >
        <div className="flex flex-col items-center justify-center">
          <EditProfile
            selectedUser={user}
            edit={true}
            onCancel={() => {
              setOpenEditUserModal(false);
            }}
            onConfirm={() => {
              setOpenEditUserModal(false);
            }}
          />
        </div>
      </CustomModal>
    </div>
  );
};

export default Header;
